// extracted by mini-css-extract-plugin
export var active = "_dq-c";
export var compactArrow = "_dq-5";
export var container = "_dq-0";
export var dot = "_dq-b";
export var dotContainer = "_dq-a";
export var hoverArrowButton = "_dq-7";
export var hoverArrowContainer = "_dq-6";
export var leftHoverArrowContainer = "_dq-8 _dq-6";
export var rightHoverArrowContainer = "_dq-9 _dq-6";
export var slide = "_dq-4";
export var sliderContainer = "_dq-1";
export var sliderContainerVisibleOverflow = "_dq-2";
export var sliderOverflow = "_dq-3";
export var vignetteBoth = "_dq-f";
export var vignetteLeft = "_dq-e";
export var vignetteRight = "_dq-d";